import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus, faMinus, faImage, faFilePowerpoint } from "@fortawesome/free-solid-svg-icons";
// import { Button, Modal } from "react-bootstrap";
// import Modal from "admin/common/Modal";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { apiUrl, assetsUrl, fileserverUrl } from "../../config/Config";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import JSZip from "jszip";
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Coupons = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [showmodal, setshowmodal] = useState(false);
    const [editshowmodal, seteditshowmodal] = useState(false);
    const [selectedid, setselectedid] = useState(0);

    
    const [layouttype, setlayouttype] = useState("");
    const [pptfile, setpptfile] = useState("");
    const [searchtags, setsearchtags] = useState([]);
    const [image, setimage] = useState("");

    const [title, settitle] = useState("");
    const [discountfor, setdiscountfor] = useState("All");
    const [couponcode, setcouponcode] = useState("");
    const [type, settype] = useState("");
    const [value, setvalue] = useState("");
    const [statedate, setstatedate] = useState("");
    const [enddate, setenddate] = useState("");
    const [emaillist, setemaillist] = useState([]);


    const selectedidRef = useRef(0);
    selectedidRef.current = selectedid;

    var prevtableobj = [
      {
        "title": "",
        "file": null
      }
    ];

    const [tabledataarr, settabledataarr] = useState(prevtableobj);

    const tabledataarrRef = useRef(prevtableobj);
    tabledataarrRef.current = tabledataarr;

    const [forceupdate, setforceupdate] = useState(false);



    const [rowData, setRowData] = useState([]);
    const [colDefs, setColDefs] = useState([]);
    const paginationPageSizeSelector = useMemo(() => {
        return [10, 20, 50, 100];
    }, []);

  const handleplusicon = () => {
    var prevobj = 
      {
        "title": "",
        "file": null
      };
    var prevdata = tabledataarrRef.current;
    prevdata.push(prevobj);
    settabledataarr(prevdata);
    setforceupdate(!forceupdate);
  }

  const handleminusicon = () => {
    var prevdata = tabledataarrRef.current;
    if(prevdata?.length == 1) {

    } else {
      prevdata.pop();
      settabledataarr(prevdata);
      setforceupdate(!forceupdate);
    }
   
  }

  const handleinputtablechange = (index, key, value) => {
    var prevdata = tabledataarrRef.current;
    prevdata[index][key] = value;
    settabledataarr(prevdata);
    setforceupdate(!forceupdate);
  }

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleinputchange = async (file) => {
    setpptfile(file);
    if (!file) {
      return;
    }

    // setProperties(null);
    // setError('');

    if (!file.name.endsWith('.pptx')) {
      // setError('Invalid file type. Please upload a .pptx file.');
      return;
    }

    try {
      const arrayBuffer = await file.arrayBuffer();
      const zip = await JSZip.loadAsync(arrayBuffer);
      
      const corePropsFile = zip.file('docProps/core.xml');

      if (corePropsFile) {
        const content = await corePropsFile.async('string');
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(content, 'application/xml');
        
        const getTagValue = (tagName) => {
            const elements = xmlDoc.getElementsByTagName(tagName);
            return elements.length > 0 ? elements[0].textContent : 'N/A';
        };

        const extractedProps = {
          title: getTagValue('dc:title'),
          author: getTagValue('dc:creator'),
          // ⬇️ This is the new line to get the keywords
          keywords: getTagValue('cp:keywords'), 
          lastModifiedBy: getTagValue('cp:lastModifiedBy'),
          revision: getTagValue('cp:revision'),
          createdDate: new Date(getTagValue('dcterms:created')).toLocaleString(),
          modifiedDate: new Date(getTagValue('dcterms:modified')).toLocaleString(),
        };

        console.log('extractedProps >>', extractedProps)
        var keywords = getTagValue('cp:keywords');
        var keywordsarr = keywords.split(', ');
        if(keywordsarr?.length > 0) {
          setsearchtags(keywordsarr);
        } else {
          
        }
        

        // setProperties(extractedProps);
      } else {
        // setError('Could not find core properties file (docProps/core.xml) in the presentation.');
      }
    } catch (e) {
      console.error(e);
      // setError('Failed to read or process the PPTX file.');
    }

  };

  const handleimagetablechange = async (index, key, file) => {
    var obj = {};
    await getBase64(file).then((result) => {
      obj["name"] = file.name;
      obj["image"] = result;
    });
    handleinputtablechange(index, key, obj);
    // console.log('obj >>', obj);
    // setimage(obj);
  };

  const handleCouponValueChange = (event) => {
    const inputValue = event.target.value;

    if (inputValue === "") {
      setvalue("");
      return;
    }

    const numericValue = Number(inputValue);
    if (
      Number.isNaN(numericValue) ||
      numericValue < 0 ||
      (type === "Percentage" && numericValue > 100)
    ) {
      return;
    }

    setvalue(inputValue);
  };

  const isCouponValueValid = () => {
    const numericValue = Number(value);
    return (
      value !== "" &&
      !Number.isNaN(numericValue) &&
      numericValue >= 0 &&
      (type !== "Percentage" || numericValue <= 100)
    );
  };

  const submithandle = async () => {
    if(!title || !discountfor || !couponcode || !type || value === "" || !statedate || !enddate) {
      alert('Select all mandatory fields!!')
      return;
    }
    if (!isCouponValueValid()) {
      alert(type === "Percentage"
        ? "Percentage value must be between 0 and 100."
        : "Coupon value must be 0 or greater.");
      return;
    }
    if(discountfor == "Users") {
      if(emaillist?.length > 0) {

      } else {
        alert('Enter Email Address')
        return;
      }
    }

    // alert('Validation Passed!!');

    var data = {
      title : title,
      discountfor: discountfor,
      couponcode: couponcode,
      type: type,
      value: value,
      startdate: statedate,
      enddate: enddate,
      emaillist: emaillist
    }

    console.log('data >>', data);

    setshowloding(true);

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .post(apiUrl + "createcoupon", data, headers)
      .then((res) => {
        // console.log('res >>>', res.data)
        if (res.data.status == "success") {
          window.location.reload();
          setshowmodal(false);
          settitle("");
          setdiscountfor("");
          setcouponcode("");
          settype("");
          setvalue("");
          setstatedate("");
          setenddate("");
          setemaillist([]);
          fetchallcourses();
          setshowloding(false);
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} })
            navigate('/admin/login');
          } else {
              alert(res.data.message);
          }
          setshowloding(false);
        }
      })
      .catch((err) => {
        setshowloding(false);
        alert(err.message);
      });

  
  setshowloding(false);
    
  };

  const edithandle = async () => {
    if(!title || !discountfor || !couponcode || !type || value === "" || !statedate || !enddate) {
      alert('Select all mandatory fields!!')
      return;
    }
    if (!isCouponValueValid()) {
      alert(type === "Percentage"
        ? "Percentage value must be between 0 and 100."
        : "Coupon value must be 0 or greater.");
      return;
    }
    if(discountfor == "Users") {
      if(emaillist?.length > 0) {

      } else {
        alert('Enter Email Address')
        return;
      }
    }

    // alert('Validation Passed!!');

    var data = {
      id: selectedidRef?.current,
      title : title,
      discountfor: discountfor,
      couponcode: couponcode,
      type: type,
      value: value,
      startdate: statedate,
      enddate: enddate,
      emaillist: emaillist
    }

    console.log('data >>', data);

    setshowloding(true);

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .post(apiUrl + "updatecoupon", data, headers)
      .then((res) => {
        // console.log('res >>>', res.data)
        if (res.data.status == "success") {
          window.location.reload();
          seteditshowmodal(false);
          settitle("");
          setdiscountfor("");
          setcouponcode("");
          settype("");
          setvalue("");
          setstatedate("");
          setenddate("");
          setemaillist([]);
          fetchallcourses();
          setshowloding(false);
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} })
            navigate('/admin/login');
          } else {
              alert(res.data.message);
          }
          setshowloding(false);
        }
      })
      .catch((err) => {
        setshowloding(false);
        alert(err.message);
      });

  
  setshowloding(false);
  };

    const clickhandle = () =>  {
        // console.log('Mission Launched')
      }

      const editlocation = async(data) => {
        setselectedid(data?.id);
        console.log('editlocation data >>', data);
        settitle(data?.title);
        setdiscountfor(data?.discountfor);
        setcouponcode(data?.couponcode);
        settype(data?.type);
        setvalue(data?.value);
        setstatedate(data?.startdate);
        setenddate(data?.enddate);
        if(data?.discountfor == "Users") {
          if(data?.coupon_users?.length > 0) {
            var couponusers = data?.coupon_users;
            var pluckemails = [];
            for(var i = 0; i < couponusers?.length; i++) {
              pluckemails.push(couponusers[i]?.user_id);
            }
            setemaillist(pluckemails);
          } else {
            setemaillist([]);
          }
        } else {
          setemaillist([]);
        }
        // setemaillist(data?.title);
        // setimage("");
        // setpptfile("");
        // settitle(data?.title);
        // setlayouttype(data?.layouttype);
        // if(data?.searchtags) {
        //   setsearchtags(data?.searchtags.split(','));
        // } else {
        //   setsearchtags([])
        // }
        // setname(data?.name);
        setTimeout(() => {
          seteditshowmodal(true);
        }, 2000);
        
      }

      const deletecourse = async (id, title) => {
        console.log('id >>', id);
        const result = window.confirm("Are you sure you want to delete coupon : " + title);
        if (result) {
          var data = JSON.stringify({
            id: id,
          });
          const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
          let resp = await axios
            .post(apiUrl + "deletelayout", data, headers)
            .then((res) => {
              if (res.data.status == "success") {
                fetchallcourses();
              } else {
              }
            })
            .catch((err) => {
              alert(err.message);
            });
        } else {
          // User clicked Cancel or closed the dialog
          // console.log("User clicked Cancel");
        }
      };

      const defaultColDef = {
        flex: 1,
      };

      const handlesubmitquestion = () => {
        console.log('hello world!!');
      }

      const handleCheckboxChange = async(t, id, title) => {
        // console.log('t >>', t.target.checked);
        if(!t.target.checked) {
          const result = window.confirm("Are you sure you want to disable coupon : " + title);
          if(result) {

          } else {
            return
          }
        }
        
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'id': id,
      'status': t.target.checked ? 'true': 'false'
    }
    let resp = await axios
    .post(apiUrl + "updatecouponstatus", data, headers)
    .then((res) => {
      if (res.data.status == "success") {
        fetchallcourses();
        setshowloding(false);
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "userdata", payload: {} })
          navigate('/admin/login');
        } else {
          alert(res.data.message);
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
  setshowloding(false);
    console.log('data >>', data);
      }


    const fetchallcourses = async () => {
        setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .get(apiUrl + "getallcoupons", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallcategories >>', res.data);
              var prevdata = res.data.data;
              if(prevdata?.length > 0) {
                var columnsarr = [];
                var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'status', 'categoryid', 'description', 'facebook', 'twitter', 'linkedin', 'instagram', 'pinterest', 'slug', 'points', 'tabledata', 'pptfile', 'searchtags', 'coupon_users'];
                var columns = Object.keys(prevdata[0]);
                // console.log('columns  >>>', columns );
                for(var i = 0; i < columns?.length;i++) {
                  if(!hidecolumns.includes(columns[i])) {
                    var obj = {};
                    obj.field = columns[i];
                    // console.log('obj >>', obj)
                    columnsarr.push(obj);
                  }
                }

                //Image
                if (columns.includes("image")) {
                  var imageobj = {
                    field: "image",
                    headerName: "Tumbnail",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <>
                          {props?.data?.image ? (
                            <Link
                              // to={assetsUrl + "images/" + props?.data?.image}
                              to={assetsUrl + props?.data?.image}
                              target="_blank"
                              style={{
                                maxWidth: 35,
                                paddingLeft: 10,
                                paddingRight: 10,
                                cursor: "pointer",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faImage}
                                className="sidebaricons"
                                style={{ color: "blue", fontSize: 18 }}
                              />
                              {/* <iframe
                                src={"https://view.officeapps.live.com/op/view.aspx?src="+assetsUrl + "ppt/" + props?.data?.pptfile}
                                width="100%"
                                height="600px"
                                frameborder="0"
                              ></iframe> */}
                            </Link>
                          ) : null}
                        </>
                      );
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  };
                  columnsarr.push(imageobj);
                }
               

                //PPT
                if (columns.includes("pptfile")) {
                  var imageobj = {
                    field: "pptfile",
                    headerName: "PPT File",
                    cellRenderer: (props) => {
                      // console.log('image props >>', props);
                      return (
                        <>
                          {props?.data?.pptfile ? (
                            <Link
                              to={assetsUrl + props?.data?.pptfile}
                              target="_blank"
                              style={{
                                maxWidth: 35,
                                paddingLeft: 10,
                                paddingRight: 10,
                                cursor: "pointer",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faFilePowerpoint}
                                className="sidebaricons"
                                style={{ color: "blue", fontSize: 18 }}
                              />
                              {/* <iframe
                                src={"https://view.officeapps.live.com/op/view.aspx?src="+assetsUrl + "ppt/" + props?.data?.pptfile}
                                width="100%"
                                height="600px"
                                frameborder="0"
                              ></iframe> */}
                            </Link>
                          ) : null}
                        </>
                      );
                    },
                    cellRendererParams: {
                      onClick: clickhandle,
                    },
                  };
                  columnsarr.push(imageobj);
                }

                //created_at
            //     if(columns.includes('created_at')) {
            //       var craetddatobj = 
            //   {
            //     field: "Date",
            //     headerName: "Date",
            //     cellRenderer: (props) => {
            //       // console.log('date props >>', props);
            //       return (
            //              <div>
            //               <p className="created_at_value">{moment(props?.data?.created_at).format('DD MMMM YYYY HH:mm')}</p>
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(craetddatobj);
            //     }

                 //status
             var statusobj = {
               field: "status",
               headerName: "Status",
               cellRenderer: (props) => {
                 // console.log('props >>', props?.data)
                 return (
                   <div className="d-flex">
                     <div class="form-check">
                       <input
                         onChange={(t) => {
                           handleCheckboxChange(
                             t,
                             props?.data?.id,
                             props?.data?.title
                           );
                         }}
                         type="checkbox"
                         class="form-check-input tableformcheck"
                         id="check1"
                         name="option1"
                         value="something"
                         style={{ marginTop: 12 }}
                         checked={
                           props?.data?.status == "true" ||
                           props?.data?.status == true
                             ? true
                             : false
                         }
                       />
                     </div>
                   </div>
                 );
               },
             };
             columnsarr.push(statusobj);
              
                //edit
              var editobj = 
              {
                field: "edit",
                headerName: "Edit",
                cellRenderer: (props) => {
                  
                  return (
                    <div
                          onClick={() => {
                            editlocation(props?.data);
                            // console.log('props >>', props?.data);
                          }}
                          style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                        >
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            className="sidebaricons"
                            style={{ color: "blue" }}
                          />
                        </div>
                  )
                },
                cellRendererParams: {
                  onClick: clickhandle,
                },
              }
              columnsarr.push(editobj);

                //delete
                var deleteobj = 
                {
                  field: "delete",
                  headerName: "Delete",
                  cellRenderer: (props) => {
                    
                    return (
                      <div
                            onClick={() => {
                              deletecourse(props?.data?.id, props?.data?.title);
                              // console.log('props >>', props?.data);
                            }}
                            style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="sidebaricons"
                              style={{ color: "red" }}
                            />
                          </div>
                    )
                  },
                  cellRendererParams: {
                    onClick: clickhandle,
                  },
                }
                columnsarr.push(deleteobj);
                setColDefs(columnsarr);
                setRowData(prevdata);
              } else {
                setColDefs([]);
                setRowData([]);
              }
              
              // setcoursesdata(res.data.data);
            } else {
              // alert(res.data.message);
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
      };
    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              //   fetchdata();
              fetchallcourses();
            } else {
              navigate("/admin/login");
            }
          }, []);

          const today = new Date().toISOString().split("T")[0];
    return (
      <div className="adminmainpagelayout">
        <div className="productstogglebar mt-2">
          <div
            className="filterdiv couponfilterdiv"
            onClick={() => {
              setimage("");
              setpptfile("");
              setshowmodal(true);
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="iconstyles"
              style={{ color: "#64748B" }}
            />
            <p>Add Coupon</p>
          </div>
        </div>

        <div
          className={"ag-theme-quartz"}
          style={{ width: "100%", height: 500, marginTop: 15 }}
        >
          <AgGridReact
            // modules={AllModules}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            // onGridReady={onGridReady}
          />
        </div>

        {/*Add modal */}
        <Modal
          show={showmodal}
          onHide={() => setshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>
              Configure New Coupon
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Title *</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Coupon Name"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Coupon Is For *</label>
                <select
                  className="form-control"
                  value={discountfor}
                  onChange={(t) => {
                    setdiscountfor(t.target.value);
                  }}
                >
                  <option value={""} selected disabled>
                    Select
                  </option>
                  <option value={"All"}>All Users</option>
                  <option value={"Users"}>Specific Users</option>
                </select>
              </div>

              {discountfor == "Users" ? (
                <div className="mt-3">
                  <label className="addproduct-label">
                    Emails (Type email address and press enter to add another email)
                  </label>
                  <TagsInput
                    value={emaillist}
                    onChange={(options) => {
                      setemaillist(options);
                    }}
                    placeholder={"Enter Email address"}
                    inputProps={{
                      className: "react-tagsinput-input",
                      placeholder: "",
                    }}
                    className="form-control tagsinputbox"
                  />
                </div>
              ) : null}

              <div className="mt-3">
                <label className="addproduct-label">Coupon Code *</label>
                <input
                  value={couponcode}
                  onChange={(t) => {
                    setcouponcode(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Coupon Code"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Coupon Type *</label>
                <select
                  className="form-control"
                  value={type}
                  onChange={(t) => {
                    const couponType = t.target.value;
                    settype(couponType);
                    if (couponType === "Percentage" && Number(value) > 100) {
                      setvalue(100);
                    }
                  }}
                >
                  <option value={""} selected disabled>
                    Select
                  </option>
                  <option value={"Credit"}>Credit</option>
                  <option value={"Percentage"}>Percentage</option>
                  <option value={"Flat"}>Flat</option>
                </select>
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Value *</label>
                <input
                  value={value}
                  onChange={handleCouponValueChange}
                  min={0}
                  max={type === "Percentage" ? 100 : undefined}
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Enter discount Value"
                />
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-6">
                  <label className="addproduct-label">Start date *</label>
                  <input
                    value={statedate}
                    onChange={(t) => {
                      setstatedate(t.target.value);
                      // Reset endDate if it's before new startDate
                      if (enddate && t.target.value > enddate) {
                        setenddate("");
                      }
                    }}
                    type="date"
                    className="form-control addproductinput"
                    placeholder="Enter Start Date"
                    min={today}
                    max={enddate || ""}
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label className="addproduct-label">End date *</label>
                  <input
                    value={enddate}
                    onChange={(t) => {
                      setenddate(t.target.value);
                    }}
                    type="date"
                    className="form-control addproductinput"
                    placeholder="Enter End Date"
                    min={statedate || today}
                  />
                </div>
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    if(showloding) {
                      
                    } else {
                      submithandle();
                    }
                    
                  }}
                >
                  {
                    showloding ?
                    <p><Spinner color="#fff" size={15} className="spinnerCenter" /></p>:
                    <p>Submit</p>
                  }
                  
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/*Edit modal */}
        <Modal
          show={editshowmodal}
          onHide={() => seteditshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Edit Coupon</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Title *</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Coupon Name"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Coupon Is For *</label>
                <select
                  className="form-control"
                  value={discountfor}
                  onChange={(t) => {
                    setdiscountfor(t.target.value);
                  }}
                >
                  <option value={""} selected disabled>
                    Select
                  </option>
                  <option value={"All"}>All Users</option>
                  <option value={"Users"}>Specific Users</option>
                </select>
              </div>

              {discountfor == "Users" ? (
                <div className="mt-3">
                  <label className="addproduct-label">
                    Emails (Type email address and press enter to add another email)
                  </label>
                  <TagsInput
                    value={emaillist}
                    onChange={(options) => {
                      setemaillist(options);
                    }}
                    placeholder={"Enter Email address"}
                    inputProps={{
                      className: "react-tagsinput-input",
                      placeholder: "",
                    }}
                    className="form-control tagsinputbox"
                  />
                </div>
              ) : null}

              <div className="mt-3">
                <label className="addproduct-label">Coupon Code *</label>
                <input
                  value={couponcode}
                  onChange={(t) => {
                    setcouponcode(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Coupon Code"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Coupon Type *</label>
                <select
                  className="form-control"
                  value={type}
                  onChange={(t) => {
                    const couponType = t.target.value;
                    settype(couponType);
                    if (couponType === "Percentage" && Number(value) > 100) {
                      setvalue(100);
                    }
                  }}
                >
                  <option value={""} selected disabled>
                    Select
                  </option>
                  <option value={"Credit"}>Credit</option>
                  <option value={"Percentage"}>Percentage</option>
                  <option value={"Flat"}>Flat</option>
                </select>
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Value *</label>
                <input
                  value={value}
                  onChange={handleCouponValueChange}
                  min={0}
                  max={type === "Percentage" ? 100 : undefined}
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Enter discount Value"
                />
              </div>

              <div className="row mt-3">
                <div className="col-12 col-sm-6">
                  <label className="addproduct-label">Start date *</label>
                  <input
                    value={statedate}
                    onChange={(t) => {
                      setstatedate(t.target.value);
                      // Reset endDate if it's before new startDate
                      if (enddate && t.target.value > enddate) {
                        setenddate("");
                      }
                    }}
                    type="date"
                    className="form-control addproductinput"
                    placeholder="Enter Start Date"
                    min={today}
                    max={enddate || ""}
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label className="addproduct-label">End date *</label>
                  <input
                    value={enddate}
                    onChange={(t) => {
                      setenddate(t.target.value);
                    }}
                    type="date"
                    className="form-control addproductinput"
                    placeholder="Enter End Date"
                    min={statedate || today}
                  />
                </div>
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    if(showloding) {
                      
                    } else {
                      edithandle();
                    }
                    
                  }}
                >
                  {
                    showloding ?
                    <p><Spinner color="#fff" size={15} className="spinnerCenter" /></p>:
                    <p>Update</p>
                  }
                  
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
}

export default Coupons
